import {
    Routes,
    Route,
} from "react-router-dom";
import LoginPageIndex from '../Pages/Login/LoginPageIndex';
import NavBar from '../Components/NavBar/NavBar';
import ShopPageIndex from '../Pages/Shop/ShopPageIndex';
import OrdersPageIndex from '../Pages/Orders/OrdersPageIndex';
import CartPageIndex from '../Pages/Cart/CartPageIndex';
import SingleProductPageIndex from '../Pages/SingleProduct/SingleProductPageIndex';
import MyAccountIndex from '../Pages/MyAccount/MyAccountIndex';
import HomePageIndex from '../Pages/Home/HomePageIndex';
import RegistrationIndex from '../Pages/Registration/RegistrationIndex';
import SaveBaskets from '../Pages/SavedBaskets/SaveBaskets';
import FinancesPageIndex from '../Pages/Finances/FinancesPageIndex';
import { ShopProvider } from '../Providers/ShopProvider';
import { OrderProvider } from '../Providers/OrderProvider';
import VersionControl from '../Components/VersionControl';
import OffersPageIndex from '../Pages/Offers/OffersPageIndex';
import HomePageAfterSelectCategory from '../Pages/Home/Components/HomePageAfterSelectCategory';
import OfferRequest from '../Pages/Offers/OfferRequest';
import OrderIndex from '../Pages/Order/OrderIndex';
import ConfirmAccountIndex from '../Pages/ConfirmAccount/ConfirmAccountIndex';
import { WarehouseProvider } from '../Providers/WarehouseProvider';
import RegistrationConfirmEmail from '../Pages/Registration/RegistrationConfirmEmail';
import ResetPassword from '../Pages/ResetPassword/ResetPassword';
import ChangePassword from '../Pages/ResetPassword/ChangePassword';
import MainThemeStylePicker from '../Components/MainThemeStylePicker';
import NavBarMobile from "../Components/MobileComponents/NavBarMobile.jsx/NavBarMobile";
import TopBarMobile from "../Components/MobileComponents/TopBarMobile/TopBarMobile";
import { useParams } from "../Providers/ParamsProvider";
import ContractorsPageIndex from "../Pages/Contractors/ContractorsPageIndex";
import CookieControl from "../Components/CookieControl";
import AboutCompanyIndex from "../Components/AboutCompanyIndex";
import OfferDetails from "../Pages/Offers/OfferDetails";
import MaintenanceGuard from "../Components/MaintenanceGuard/MaintenanceGuard";

const RoutesManagment = () => {
    const { isMobile } = useParams()
    return (
        <ShopProvider>
            <OrderProvider>
                <WarehouseProvider>
                    <MainThemeStylePicker />
                    <VersionControl />
                    <CookieControl />
                    <MaintenanceGuard>
                        {isMobile ? <NavBarMobile /> : <NavBar />}
                        {isMobile && <TopBarMobile />}
                        <Routes>
                            <Route path='ConfirmAccount' element={<ConfirmAccountIndex />} />
                            <Route path='AccountCreated' element={<RegistrationConfirmEmail />} />
                            <Route path='ResetPassword' element={<ResetPassword />} />
                            <Route path='ChangePassword' element={<ChangePassword />} />

                            <Route path='/' element={<HomePageIndex />} />
                            <Route path='login' element={<LoginPageIndex />} />
                            <Route path='Registration' element={<RegistrationIndex />} />
                            <Route path='CategoryDetails' element={<HomePageAfterSelectCategory />} />
                            <Route path='Shop' element={<ShopPageIndex />} />
                            <Route path='Finances' element={<FinancesPageIndex />} />
                            <Route path='Offers' element={<OffersPageIndex />} />
                            <Route path='OfferRequest/:mode/:forceLoad/:requestOfferNo' element={<OfferRequest />} />
                            <Route path='Contractors' element={<ContractorsPageIndex />} />
                            <Route path='Orders' element={<OrdersPageIndex />} />
                            <Route path="Cart" element={<CartPageIndex />} />
                            <Route path='MyAccount' element={<MyAccountIndex />} />
                            <Route path="product/:index" element={<SingleProductPageIndex />} />
                            <Route path='SavedBaskets' element={<SaveBaskets />} />
                            <Route path='Order/:orderNumber' element={<OrderIndex />} />
                            <Route path="About" element={<AboutCompanyIndex />} />
                            <Route path='OfferDetails/:offerNo/:offerSiteId/:isOfferRequest' element={<OfferDetails />} />
                        </Routes>
                    </MaintenanceGuard>
                </WarehouseProvider>
            </OrderProvider>
        </ShopProvider>
    )
}

export default RoutesManagment